import { actionCreator } from '../helpers';
import { ORGANISATIONS_INPUT } from './topics';
import * as Deployment from '../deployment';

export const exportRequest = actionCreator({
  type: Deployment.exportRequest.type,
  schema: Deployment.exportRequest.schema,
  topic: ORGANISATIONS_INPUT,
  creator: (payload: Deployment.IExportRequestPayload) =>
    Deployment.exportRequest(payload),
});
